/* Blastoys B2B homepage polish — scroll reveal.
   Same proven pattern as assets/blastoys-anim.js from the earlier theme
   lineage: IntersectionObserver with a failsafe timeout (a broken observer
   must never leave content stuck at opacity:0 forever), staggered by
   sibling position, re-runs on theme-editor section swap. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var targets = (root || document).querySelectorAll('.bt-reveal');
    if (!targets.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('bt-in'); });
      return;
    }

    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('bt-in'); });
    }, 1500);

    if (document.visibilityState === 'hidden') {
      document.addEventListener('visibilitychange', function onVis() {
        if (document.visibilityState !== 'visible') return;
        document.removeEventListener('visibilitychange', onVis);
        targets.forEach(function (el) { el.classList.add('bt-in'); });
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bt-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    targets.forEach(function (el) {
      if (!el.style.getPropertyValue('--bt-delay') && el.parentElement) {
        var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) {
          return c.classList.contains('bt-reveal');
        });
        var i = sibs.indexOf(el);
        if (i > 0) el.style.setProperty('--bt-delay', Math.min(i * 85, 500) + 'ms');
      }
      io.observe(el);
    });
  }

  function init(root) {
    try { reveal(root); } catch (e) { /* one broken bit must not hide the page */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
